import React from 'react'

export default function Privacy() {
  return (
    <div className="container">
      <section className="card">
        <h2 className="h2">Privacy Policy</h2>
        <p className="kv">Last updated: <strong>Nov 1, 2025</strong></p>
        <p className="kv">We take user privacy seriously. This page is a starter template — replace with a full privacy policy for production use in your jurisdiction.</p>
      </section>
    </div>
  )
}
